module.exports = __webpack_public_path__ + "static/media/clem-onojeghuo-1.23b27a07.jpg";